import { get } from '@tovala/browser-apis-combinedapi'

export interface MenuProductRatingAverage {
  mealID: number
  // Stars multiplied by 100, as an integer (430 is 4.3 stars)
  averageRating: number
}

export interface GetMenuProductRatingAveragesRequest {
  menuID: string
}

export interface GetMenuProductRatingAveragesResponse {
  ratingAverages: MenuProductRatingAverage[]
}

export const ENDPOINTS = {
  GET_MENU_PRODUCT_RATING_AVERAGES: ({
    menuID,
  }: Pick<GetMenuProductRatingAveragesRequest, 'menuID'>) => ({
    path: `/menus/${menuID}/menuProductRatingAverages`,
    version: 'v2' as const,
  }),
}

export async function getMenuProductRatingAverages({
  menuID,
}: GetMenuProductRatingAveragesRequest) {
  return get<GetMenuProductRatingAveragesResponse>(
    ENDPOINTS.GET_MENU_PRODUCT_RATING_AVERAGES({ menuID }),
  )
}
